import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';
import { Brand } from 'src/typings';

import { BrandService } from '../brand.service';
import { CreateComponent } from '../create/create.component';

@Component({
  selector: 'app-brand-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss']
})
export class SelectorComponent implements OnInit {
  constructor(private brandService: BrandService, public dialog: MatDialog) {}

  brands: Observable<Brand[]> = this.brandService
    .getAllBrands()
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));

  filteredOptions: Observable<Brand[]> = new Observable();

  value: any;

  @Input() control: UntypedFormControl = new UntypedFormControl('');

  @Input() loadOnFocus = false;

  optionsActivated = false;

  public displayProperty(brand: any) {
    if (brand) {
      return brand.description;
    }
    return;
  }

  ngOnInit(): void {
    this.filteredOptions = combineLatest([
      this.control.valueChanges.pipe(startWith(this.control.value)),
      this.brands
    ]).pipe(
      map(([value, brands]) => {
        const query =
          typeof value === 'string' ? value.toLowerCase() : value?.description?.toLowerCase();
        return brands.filter((brand) => !query || brand.description.toLowerCase().includes(query));
      })
    );
  }

  openDialog() {
    const dialogRef = this.dialog.open(CreateComponent, {
      width: '500px'
    });
    dialogRef.componentInstance.control = this.control;
    dialogRef.componentInstance.dialogRef = dialogRef;
  }

  handleSelect(event: MatAutocompleteSelectedEvent) {
    if (typeof event.option.value === 'string') {
      this.openDialog();
    }
  }
}
